<template>
    <div>
        <el-input :value="text" v-if="isTure" placeholder="请选择" :class="{'append-bg-none': !disabled, 'input-with-select': true, picker: true}" :size="size" :disabled="true">
            <el-button slot="append" type="info" plain :size="size" :disabled="disabled" @click="open">
                <i class="fa fa-external-link"></i>
            </el-button>
        </el-input>
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @close="close">
            <el-row>
                <el-row class="bottom20">
                    <el-table ref="table" :data="page.records"
                              highlight-current-row
                              @current-change="handleCurrentRowChange">
                        <el-table-column width="55">
                            <template slot-scope="scope">
                                <el-radio class="label-hidden" :value="currentRow == null ? null : currentRow.assetId" :label="scope.row.assetId"></el-radio>
                            </template>
                        </el-table-column>
                        <el-table-column prop="assetNum">
                            <template slot="header" slot-scope="scope">
                                资产编号<br>
                                <el-input size="mini" v-model="pageSearch.search.assetNum" placeholder="资产编号"></el-input>
                            </template>
                            <template slot-scope="scope">
                                {{scope.row.assetNum}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="assetTag">
                            <template slot="header" slot-scope="scope">
                                设备编号<br>
                                <el-input size="mini" v-model="pageSearch.search.assetTag" placeholder="设备编号"></el-input>
                            </template>
                            <template slot-scope="scope">
                                {{scope.row.assetTag}}
                            </template>
                        </el-table-column>

                        <el-table-column prop="description">
                            <template slot="header" slot-scope="scope">
                                设备描述<br>
                                <el-input size="mini" v-model="pageSearch.search.description" placeholder="设备描述"></el-input>
                            </template>
                            <template slot-scope="scope">
                                {{scope.row.description}}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row type="flex" class="row-bg" justify="end">
                    <el-pagination
                            @current-change="handleCurrentChange"
                            @size-change="handleSizeChange"
                            :current-page="pageSearch.current"
                            :page-sizes="[10, 25, 50, 100]"
                            :page-size="pageSearch.size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.total">
                    </el-pagination>
                </el-row>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel" size="small">取 消</el-button>
                <el-button @click="confirm" size="small" type="primary">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import { debounce, merge } from "@/util/common"
    import DictionarySelect from '@/components/common/DictionarySelect'
    import DictionaryText from '@/components/common/DictionaryText'
    import {page} from  '@/mixins/table'

    import PageUtils from '@/util/common/page-utils'

    import AssetServer from '@/api/asset'

    export default {
        name: "EquipmentPicker",
        mixins: [page],
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            size: {
                type: String,
            },
            dialogTitle: {
                type: String,
                default: '选择设备',
            },
            textKey: {
                type: String,
                default: 'description',
            },
            text: {
                type: String,
            },
            search: {
                type: Object,
            }
        },
        data() {
            return {
                dialogVisible: false,
                key: 'equipmentid',
                currentRow: null,
                isTure:false,
                pageSearch: {
                    search: {
                        assetNum: '',
                        assetTag:'',
                        description: '',
                        assetType: '',
                        appId: "WEB",
                        token: localStorage.getItem("token"),
                        roomId:''

                    }
                }
            }
        },
        watch: {
            search: {
                immediate: true,
                handler(value) {
                    if (value != null) {
                        this.pageSearch.search = merge(true, this.pageSearch.search, value);
                    }
                }
            },
        },
        methods: {
            queryByPage: debounce(function(pageSearch) {
                AssetServer.equipment.page(PageUtils.pageSearch2Old(pageSearch)).then((res) => {

                    if (res.data.code === 200) {
                    this.page = {
                        total: res.data.data.iTotalRecords,
                        records: res.data.data.aaData,
                    };
                }
            });
            }, 200),
            handleCurrentRowChange(val) {
                this.currentRow = val;
            },
            setCurrentRow(row) {
                this.$refs.table.setCurrentRow(row);
            },
            cancel() {
                this.currentRow = null;
                this.setCurrentRow();
                this.dialogVisible = false;
            },
            confirm() {
                if (this.currentRow != null) {
                    this.dialogVisible = false;
                    this.$emit('change', this.currentRow);
                } else {
                    this.$confirm('没有选择设备，确定清空吗？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.dialogVisible = false;
                    this.$emit('change', {});
                }, () => {});
                }
            },
            open() {
                this.dialogVisible = true;
                this.currentRow = null;
                this.reQueryByPage();
            },
            close() {
                this.pageSearch.search.assetType = '';
                this.pageSearch.search.assetNum = '';
                this.pageSearch.search.assetTag = '';
                this.pageSearch.search.description = '';
                this.pageSearch.search.roomId = '';
                this.dialogVisible = false;
            }
        }
    }
</script>

<style scoped>
    .picker button.is-disabled {
        border-color: transparent;
        background-color: transparent;
        color: inherit;
        border-top: 0;
        border-bottom: 0;
    }
</style>
